<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQZNsOPiyoth01CRxQ09y1kpkHUhSnu32i-kWCFUKJUGU7SFVGM"
        class="img-avatar"
        alt="admin@bootstrapmaster.com"
      />
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center">
        <strong>Account</strong>
      </b-dropdown-header>
      <b-dropdown-item href="/reset">
        <i class="fa fa-undo" />Reset Password
      </b-dropdown-item>
      <b-dropdown-item href="/logout" @click="clearLocalStorage">
        <i class="fa fa-lock" />Logout
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'Userdropdown',
  components: {
    AppHeaderDropdown,
  },
  data: () => {
    return { itemsCount: 42 }
  },
  methods: {
    clearLocalStorage() {
      localStorage.removeItem('selectedGrpId')
      localStorage.removeItem('selectedOutlet')
      localStorage.removeItem('oloStatus')
      localStorage.removeItem('invEnabledOutlets')
      localStorage.removeItem('promotionOutlets')
      localStorage.removeItem('auth.authDetails')
      sessionStorage.removeItem('auth.authDetails')
    },
  },
}
</script>
